
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 81 81","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M72.412 0C77.155 0 81 4.352 81 9.72v61.56c0 5.368-3.845 9.72-8.588 9.72H8.588C3.845 81 0 76.648 0 71.28V9.72C0 4.352 3.845 0 8.588 0h63.824zm-30.7 45.143l16.43-.008V41.43v-3.715l-16.43.016h-2.799l-16.056-.016V45.135l16.056.008h2.8z","fill":"#515358","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/clearSelection.svg